import Hero from './Hero';
import Services from './Services';
import Testimonials from './Testimonials';
import SEO from './shared/SEO';

const Home = () => {
    return (
      <>
        <SEO
          path="/"
          description="Book a verified massage therapist online in Nigeria. Serenoly matches you with professional therapists for home, hotel, or spa sessions — with escrow-protected payment and real-time matching."
        />
        <Hero />
        <Services />
        <Testimonials />
      </>
    );
  };

  export default Home;
